import React from 'react';
import Lottie from 'lottie-react';
import lottianimated404 from './404 error.json';

export default function Pagenotfount() {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fffaf0',
        color: '#dbaa4f',
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center',
        gap: '1.5rem',
        padding: '1rem',
      }}
    >
      <div
        style={{
          width: '320px',
          maxWidth: '90%',
        }}
      >
        <Lottie animationData={lottianimated404} loop={true} />
      </div>

      <h1
        style={{
          fontSize: '2rem',
          fontWeight: 700,
          margin: 0,
        }}
      >
        Page Not Found
      </h1>

      <p
        style={{
          fontSize: '1rem',
          color: '#8b6b2e',
          maxWidth: '400px',
          lineHeight: 1.6,
          margin: 0,
        }}
      >
        Sorry, the page you’re looking for doesn’t exist or has been moved.
      </p>

      <a
        href="/"
        style={{
          marginTop: '1rem',
          backgroundColor: '#dbaa4f',
          color: '#fff',
          padding: '0.3rem 1.5rem',
          borderRadius: '8px',
          textDecoration: 'none',
          fontWeight: 600,
          transition: 'all 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#c2913e';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = '#dbaa4f';
        }}
      >
        Go Home
      </a>
    </div>
  );
}
